export const paymentError = method =>
  `An unexpected error occurred with ${method}. Please refresh and try again.`;
export const reauthenticatePaymentError = method => `Please authenticate with ${method} again.`;

export const PREPAID_CARD_ERROR_MESSAGE =
  'Home Chef does not accept prepaid cards. Please use another payment method.';
export const GENERIC_ERROR_MESSAGE =
  'An error has occurred. Please refresh the page and try again or contact support if the error persists.';
export const STRIPE_NOT_INITIALIZED_ERROR_MESSAGE =
  'Stripe has not initialized yet. Please refresh the page and try again.';
export const STRIPE_PAYMENT_METHOD_CREATION_ERROR_MESSAGE = 'Unable to create payment method.';
